//export var codeUrl="http://maoyp.natapp4.cc"
//export var codeUrl="https://park.natapp4.cc"
//export var codeUrl="https://www.test.51zhykj.com"
//export var codeUrl="https://www.parking.52zhysq.com"
//export var codeUrl="https://www.51zhykj.com"//衢州
export const codeUrl=`${window.location.protocol}//${window.location.host}`
const SYSTEM_CONFIG={
    COMMON:{
        PLATFORM_NAME:'智慧城市车辆静态交通运管服务平台',
        LOGO_NAME:'城市停车平台',
        BERTH_LIST_VIDEO_FIELD:false
    },
    JSS:{
        PLATFORM_NAME:'积石山县智慧停车管理平台',
        LOGO_NAME:'积石山智慧停车平台',
        BERTH_LIST_VIDEO_FIELD:false
    },
    XH:{
        PLATFORM_NAME:'夏河县智慧停车管理平台',
        LOGO_NAME:'夏河智慧停车平台',
        BERTH_LIST_VIDEO_FIELD:false
    },
    DGWJ:{
        PLATFORM_NAME:'智慧城市车辆静态交通运管服务平台',
        LOGO_NAME:'城市停车平台',
        BERTH_LIST_VIDEO_FIELD:true
    }
   
}
export default{
    ...SYSTEM_CONFIG.XH
}
